module.exports = __webpack_public_path__ + "img/back.97722fbe.png";